import { useQuery } from "@tanstack/react-query";
import { brandGuideAPI, BrandGuideCategory } from "../api";

// Get all brand guide items
export const useGetBrandGuideItems = () => {
  return useQuery({
    queryKey: ["brandGuideItems"],
    queryFn: () => brandGuideAPI.getAllItems(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Get brand guide items by category
export const useGetBrandGuideItemsByCategory = (
  category: BrandGuideCategory
) => {
  return useQuery({
    queryKey: ["brandGuideItems", category],
    queryFn: () => brandGuideAPI.getItemsByCategory(category),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Get single brand guide item by ID
export const useGetBrandGuideItemById = (id: string) => {
  return useQuery({
    queryKey: ["brandGuideItem", id],
    queryFn: () => brandGuideAPI.getItemById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Custom hook to organize items by category
export const useGetBrandGuideItemsGrouped = () => {
  const { data: items, ...rest } = useGetBrandGuideItems();

  const groupedItems = items ? groupItemsByCategory(items) : null;

  return {
    ...rest,
    data: groupedItems,
  };
};

// Helper function to group items by category
const groupItemsByCategory = (items: any[]) => {
  return items.reduce((acc, item) => {
    const category = item.category;
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(item);
    return acc;
  }, {});
};
